import { Injectable, signal } from '@angular/core';

import { storedSignal } from '../shared';

@Injectable({ providedIn: 'root' })
export class Token {
  social = storedSignal('lcm:idToken', '');
  auth = signal('');
}
